import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import API from "../services/API";
import { extractErrorMessage } from "../utils/errorMessage";

export default function AlreadyLoggedIn() {
 const navigate = useNavigate();
 const [searchParams] = useSearchParams();
 const email = searchParams.get("email") ??"";

 const [loading, setLoading] = useState(false);
 const [feedback, setFeedback] = useState<
 { type: "success" | "error"; message: string } | null
 >(null);

 const handleLogoutAll = async () => {
 setLoading(true);
 setFeedback(null);
 try {
 await API.post("/api/auth/logout-all", { email });
 setFeedback({
 type: "success",
 message: "Successfully logged out all sessions. You can now log in.",
 });
 } catch (err) {
 console.error("Logout all sessions error: ", err);
 setFeedback({
 type: "error",
 message: extractErrorMessage(err,"Failed to logout sessions. Try again."),
 });
 } finally {
 setLoading(false);
 }
 };

 return (
 <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-slate-950">
 <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-emerald-50/40"/>
 <div className="pointer-events-none absolute -right-40 -top-40 h-[34rem] w-[34rem] rounded-full bg-emerald-300/30 blur-3xl"/>
 <div className="pointer-events-none absolute -bottom-48 -left-32 h-[34rem] w-[34rem] rounded-full bg-emerald-300/30 blur-3xl"/>

 <div className="relative mx-auto w-full max-w-md px-4">
 <div className="rounded-3xl border border-white/60 bg-white/80 p-8 shadow-2xl backdrop-blur-xl">
 <div className="text-center">
 <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100">
 <svg
 className="h-6 w-6 text-role-primary"viewBox="0 0 24 24"fill="none"stroke="currentColor"strokeWidth="2">
 <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
 <path d="M12 8v4"/>
 <path d="M12 16h.01"/>
 </svg>
 </div>

 <h2 className="text-xl font-bold text-slate-900">
 Already logged in
 </h2>
 <p className="mt-2 text-sm text-slate-600">
 You have already logged in on this device. Please click the
 button below to logout all sessions, then try logging in again.
 </p>

 {email && (
 <p className="mt-3 text-xs text-slate-500">
 Account: <span className="font-medium text-slate-700">{email}</span>
 </p>
 )}

 {feedback && (
 <div
 className={`mt-4 rounded-lg border px-4 py-3 text-sm ${
 feedback.type ==="success"?"border-slate-200 bg-white text-role-primary":"border-rose-200 bg-rose-50 text-rose-700"}`}
 >
 {feedback.message}
 </div>
 )}

 <div className="mt-6 flex flex-col gap-3">
 <button
 type="button"onClick={handleLogoutAll}
 disabled={loading}
 className="inline-flex w-full items-center justify-center rounded-xl bg-rose-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-60">
 {loading ?"Logging out...":"Logout all sessions"}
 </button>

 <button
 type="button"onClick={() => navigate("/", { replace: true })}
 className="inline-flex w-full items-center justify-center rounded-xl border border-slate-200 bg-white px-5 py-2.5 text-sm font-semibold text-role-primary shadow-sm transition hover:bg-emerald-100">
 Go back to login
 </button>
 </div>
 </div>
 </div>
 </div>
 </div>
 );
}
